(function ( $ ) {

	$.fn.accessibility = function () {
		var elem = $( this ),
			parent = elem.parent(),
			$html = $( 'html' ),
			$body = $( 'body' ),

			inititalTextSize = parseInt( $html.css( 'font-size' ) ),

			textSizeIncrements = 10, // an int, but actually used as a percentage,
			$textOptionsContainer = elem.find( '.accessibility-options__text' ),
			$textOptionsValue = $textOptionsContainer.find( '.value' ),
			$textOptionsTogglers = $textOptionsContainer.find( '.accessibility-options__button' ),

			$contrastOptionsContainer = elem.find( '.accessibility-options__contrast' ),
			$contrastOptionsValue = $contrastOptionsContainer.find( '.value' ),
			$contrastOptionsTogglers = $contrastOptionsContainer.find( '.accessibility-options__button' ),
			contrastOptions = {
				'w-on-b'  : 'White text and black background',
				'b-on-w'  : 'Black text and white background',
				'y-on-b'  : 'Yellow text and black background',
				'default' : 'Default'
			},

			$soundOptionsContainer = elem.find( '.accessibility-options__sound' ),
			$soundOptionsValue = $soundOptionsContainer.find( '.value' ),
			$soundOptionsToggler = $soundOptionsContainer.find( '.accessibility-options__button' ),
			$soundOptionsTogglerContainer = $soundOptionsContainer.find( '.accessibility-options__buttons--speaker-bg' ),

			currPreferences,
			defaultPreferences = {
				textSize     : 100, // percentage base
				contrastMode : 'default',
				soundOn      : true
			};

		var init = function () {

				if(typeof CAF == 'undefined') {
					CAF = {};
				}

				if(typeof CAF.OPTIONS == 'undefined') {
					CAF.OPTIONS = {};
				}
			
			

				getCookiePreferences();

				//console.log( 'Current Accessibility Prefs', currPreferences );


				adjustTextSize();
				adjustContrastMode();
				adjustSoundMode();

			

				saveCookiePreferences();

				bindEvents();

			},

			bindEvents = function () {

				$textOptionsTogglers.on( 'click', function ( e ) {
					var moreOrLess = $( this ).hasClass( 'text--plus' );

					adjustTextSize( moreOrLess );
				} );


				$contrastOptionsTogglers.on( 'click', function ( e ) {
					adjustContrastMode( $( this ).data( 'contrast-option' ) );
				} );


				$soundOptionsTogglerContainer.on( 'click', function ( e ) {
					adjustSoundMode( $( this ).hasClass( 'sound-mode--off' ) );
				} );
			},

			adjustTextSize = function ( boolMoreOrLess, resetToDefaultSize ) {

				if ( typeof boolMoreOrLess !== 'undefined' &&
					(typeof resetToDefaultSize == 'undefined' || resetToDefaultSize == false)
				) {

					if ( boolMoreOrLess ) {
						currPreferences.textSize = currPreferences.textSize + textSizeIncrements;
					} else {
						currPreferences.textSize = currPreferences.textSize - textSizeIncrements;
					}

					$html.css( {
						'font-size' : Math.floor( inititalTextSize * ( currPreferences.textSize / 100 ) )
					} );


					saveCookiePreferences();
				} else if ( typeof resetToDefaultSize != 'undefined' ) {
					currPreferences.textSize = 100;

					$html.css( {
						'font-size' : inititalTextSize
					} );
				} else {

					$html.css( {
						'font-size' : Math.floor( inititalTextSize * ( currPreferences.textSize / 100 ) )
					} );
				}

				$textOptionsValue.html( currPreferences.textSize + "%" );
			},

			adjustContrastMode = function ( contrastMode ) {

				if ( typeof contrastMode != 'undefined' && contrastMode != currPreferences.contrastMode ) {
					$contrastOptionsTogglers.removeClass

					$.each( contrastOptions, function ( key, val ) {
						$body.removeClass( 'contrast-mode--' + key );
					} );
					$body.addClass( 'contrast-mode--' + contrastMode );

					$contrastOptionsTogglers.removeClass( 'is-active' );
					$contrastOptionsTogglers.filter( '[data-contrast-option="' + contrastMode + '"]' ).addClass( 'is-active' );

					currPreferences.contrastMode = contrastMode;

					saveCookiePreferences();

				} else {
					// Default / initial view
					$body.addClass( 'contrast-mode--' + currPreferences.contrastMode );
					$contrastOptionsTogglers.filter( '[data-contrast-option="' + currPreferences.contrastMode + '"]' ).addClass( 'is-active' );
				}


				if ( typeof contrastOptions[ currPreferences.contrastMode ] != 'undefined' ) {
					$contrastOptionsValue.html( contrastOptions[ currPreferences.contrastMode ] );
				}
			},

			adjustSoundMode = function ( boolSwitchOn ) {

				var currModeString,
					currClassString;

				if ( typeof boolSwitchOn != 'undefined' ) {
					currPreferences.soundOn = boolSwitchOn;
				}

				currModeString = currPreferences.soundOn == true ? "On" : "Off";
				currClassString = currPreferences.soundOn == true ? "on" : "off";

				$soundOptionsValue.html( currModeString );

				$soundOptionsToggler.add( $soundOptionsTogglerContainer )
					.removeClass( 'sound-mode--off sound-mode--on' )
					.addClass( 'sound-mode--' + currClassString );

				CAF.OPTIONS.soundOn = currPreferences.soundOn;

				saveCookiePreferences();
			},
			getCookiePreferences = function () {
				var savedPrefs = Cookies.getJSON( 'caf-accessibility-preferences' );

				if ( savedPrefs ) {
					currPreferences = $.extend( {}, defaultPreferences, savedPrefs );
				} else {
					currPreferences = defaultPreferences;
				}
				
				CAF.OPTIONS.soundOn = currPreferences.soundOn;
			},
			saveCookiePreferences = function () {
				Cookies.set( 'caf-accessibility-preferences', currPreferences, { expires : 365 } );
			};


		init();
		return this;
	};

}( jQuery ));
